(function () {
  'use strict';

  angular.module('app').component('paymentGatewaysPage', paymentGatewaysListCtrl());

  function paymentGatewaysListCtrl() {
    return {
      bindings: {},
      controller: PaymentGatewaysListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/payment-gateways/payment-gateways-page.component.html',
    };
  }

  PaymentGatewaysListCtrl.$inject = [
    'UtilService',
    'PaymentGatewayService',
    'PaymentMethodService',
    'LanguageService',
    'SessionService',
  ];

  function PaymentGatewaysListCtrl(UtilService, PaymentGatewayService, PaymentMethodService, LanguageService, SessionService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    // public methods
    // -----------------------
    vm.onShowPaymentGateway = function (paymentGateway, mode) {
      PaymentGatewayService.openPaymentGatewayModal(
        paymentGateway,
        mode,
        vm.paymentMethods,
        vm.defaultLanguage,
        vm.additionalLanguages
      );
    };

    // private methods
    // -----------------------
    getAdditionalLanguages();

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getPaymentGateways();
        getPaymentMethods();
      });
    }

    function getPaymentGateways() {
      vm.loadingPaymentGateways = true;
      PaymentGatewayService.getPaymentGateways({ lang: SessionService.getUserLanguage().code }).then(function (data) {
        vm.paymentGateways = data || [];

        vm.loadingPaymentGateways = false;
      });
    }

    function getPaymentMethods() {
      PaymentMethodService.getPaymentMethods({ get: 'active', skip_check_role: true }).then(
        function (data) {
          vm.paymentMethods = data.items;
        }
      );
    }
  }
})();
